import { render } from "./SummaryStats.vue?vue&type=template&id=cd327cd8&scoped=true"
import script from "./SummaryStats.vue?vue&type=script&lang=js"
export * from "./SummaryStats.vue?vue&type=script&lang=js"

import "./SummaryStats.vue?vue&type=style&index=0&id=cd327cd8&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd327cd8"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
